var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerSmGreenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C8.5314 2 5.7 4.86 5.7 8.36364C5.7 10.5545 6.807 12.5018 8.4846 13.6482C5.2743 15.0391 3 18.2545 3 22H4.8C4.8 17.9727 8.013 14.7273 12 14.7273C15.987 14.7273 19.2 17.9727 19.2 22H21C21 18.2545 18.7257 15.0382 15.5154 13.6473C16.3718 13.0637 17.0735 12.2768 17.559 11.3557C18.0445 10.4345 18.2989 9.40718 18.3 8.36364C18.3 4.86 15.4686 2 12 2ZM12 3.81818C14.4957 3.81818 16.5 5.84273 16.5 8.36364C16.5 10.8845 14.4957 12.9091 12 12.9091C9.5043 12.9091 7.5 10.8845 7.5 8.36364C7.5 5.84273 9.5043 3.81818 12 3.81818Z",
    fill: "#27AE60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSmGreenIcon);
export default __webpack_public_path__ + "static/media/customer-sm-green-icon.dd6ba8102ad6e43d7a8b22cc35f9d99f.svg";
export { ForwardRef as ReactComponent };